/* Explicit Campaign purchase for comparison cards. Shopify owns all allocations. */
(function (global) {
  'use strict';
  if (global.MAFCampaignPurchase) return;
  const list = value => Array.isArray(value) ? value : [];
  const id = value => String(value || '').split('/').pop();
  function items(config) {
    const lines = list(config.items);
    if (!lines.length || lines.some(line => !/^\d+$/.test(id(line.id)) || Number(id(line.id)) < 1 || !Number.isSafeInteger(line.quantity) || line.quantity < 1)) throw new Error('This bundle is unavailable. Refresh the page to review it.');
    return lines.map(line => ({...line, id:Number(id(line.id)), ...(line.properties ? {properties:{...line.properties}} : {})}));
  }
  function promotion(config) {
    const value = global.MAFCommerce.resolvePromotion(config.promotion);
    if (!value || config.promotion.previewOnly) throw new Error('This Campaign has changed or is unavailable. Refresh the page to review the current offer.');
    if (!value.eligibleProducts.has(id(config.productId))) throw new Error('This product is unavailable for the selected Campaign. Open its product page to review your options.');
    return value;
  }
  function fingerprint(config) {
    const current = promotion(config);
    return JSON.stringify([config.productId, config.cartMode, config.promotion.country, config.promotion.currency, current.schedule, items(config), config.products]);
  }
  function cartQuantity(current, cart) {
    // Cash Campaigns have an explicit native qualifying Product set. A newly
    // encountered cart Product never expands that set.
    const knownProducts = new Set(current.knownProducts);
    for (const line of list(cart.items)) {
      if (!/^\d+$/.test(id(line.product_id || line.productId))) throw new Error('Cart details changed. Refresh your cart before continuing.');
      knownProducts.add(id(line.product_id || line.productId));
    }
    return global.MAFCommerce.count({...current, knownProducts}, cart.items);
  }
  function selectionQuantity(current, config, lines) {
    const products = new Map(list(config.products).map(product => [id(product.variantId), id(product.productId)]));
    return global.MAFCommerce.count(current, lines.map(line => {
      const product = products.get(id(line.id));
      if (!product) throw new Error('This bundle needs to be reviewed on its product page.');
      return {product_id:product, quantity:line.quantity};
    }));
  }
  async function catalog(product) {
    const api = global.MAFCommerce;
    if (typeof product.handle !== 'string' || !product.handle || /[/?#]/.test(product.handle)) throw new Error('Product details are unavailable. Refresh the page.');
    const result = await api.request('products/' + encodeURIComponent(product.handle) + '.js');
    if (!api.catalogProductMatches(product, result)) throw new Error('Product price or availability changed. Refresh the page to review this offer.');
  }
  async function refreshConfig(original) {
    if (!original.sectionId || !original.configId) throw new Error('Campaign details are unavailable. Refresh the page.');
    const url = new URL(global.location.href);
    url.searchParams.delete('sections');
    url.searchParams.set('section_id', original.sectionId);
    const response = await global.fetch(url.pathname + url.search, {credentials:'same-origin', cache:'no-store', headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error('The current Campaign could not be checked. Please try again.');
    const document = new global.DOMParser().parseFromString(await response.text(), 'text/html');
    const source = document.getElementById(original.configId);
    if (!source || !source.hasAttribute('data-maf-campaign-purchase-config')) throw new Error('This offer has changed. Refresh the page to review it.');
    const fresh = JSON.parse(source.textContent);
    if (fresh.configId !== original.configId || fresh.sectionId !== original.sectionId || fingerprint(fresh) !== fingerprint(original)) throw new Error('This offer has changed. Refresh the page to review it before adding.');
    return fresh;
  }
  async function purchase(original) {
    const commerce = global.MAFCommerce, adapter = global.MAFCartDiscounts, gifts = global.MAFPromotionGift;
    if (!commerce || !adapter || !gifts) throw new Error('Purchase details are still loading. Please try again.');
    if (original.promotion?.previewOnly || global.Shopify?.designMode) throw new Error('Campaign preview is display only. Open the storefront to purchase.');
    if (commerce.busy || adapter.busy) throw new Error('Your cart is updating. Please wait before adding another offer.');
    commerce.busy = true; adapter.busy = true;
    let attempted = false, token = null, selectedGift = null, giftCode = '';
    try {
      const config = await service.refreshConfig(original);
      if (config.cartMode !== 'components') throw new Error('Review this bundle on its product page before purchasing.');
      let current = promotion(config);
      const lines = items(config);
      const selected = selectionQuantity(current, config, lines);
      const checks = new Map();
      for (const product of list(config.products)) {
        const key = id(product.variantId);
        if (!checks.has(key)) checks.set(key, catalog(product));
      }
      await Promise.all(checks.values());
      let cart = await adapter.request('cart.js');
      if (cart.currency !== config.promotion.currency) throw new Error('Your market or currency changed. Refresh the page.');
      if (current.cash && cartQuantity(current, cart) + selected >= Number(current.schedule.gift.minimum)) {
        const eligible = list(current.schedule.gift.products).filter(product => product.available === true && product.variantCount === 1 && Number.isSafeInteger(product.price) && product.price > 0);
        if (eligible.length !== 1 || current.schedule.gift.maximum !== 1) throw new Error('Select your gift on the product page before continuing.');
        selectedGift = eligible[0];
        await catalog(selectedGift);
      }
      // Recheck time, currency and cart immediately before the single add.
      current = promotion(config);
      cart = await adapter.request('cart.js');
      if (cart.currency !== config.promotion.currency) throw new Error('Your market or currency changed. Refresh the page.');
      if (current.cash && cartQuantity(current, cart) + selected >= Number(current.schedule.gift.minimum)) {
        if (!selectedGift) throw new Error('Your cart changed. Please review this offer and try again.');
        giftCode = current.schedule.gift.code;
        if (!gifts.existingGift(cart, selectedGift) && !lines.some(line => id(line.id) === id(selectedGift.variantId))) {
          token = id(current.schedule.id) + '-' + Date.now() + '-' + Math.random().toString(36).slice(2);
          lines.push({id:Number(id(selectedGift.variantId)), quantity:1, properties:{_maf_campaign_gift:id(current.schedule.id), _maf_gift_version:'public_v1', _maf_gift_claim:token}});
        }
      } else {selectedGift = null;}
      attempted = true;
      await adapter.request('cart/add.js', {items:lines});
      cart = await adapter.request('cart.js');
      if (cart.currency !== config.promotion.currency) throw new Error('Your market or currency changed. Review your cart.');
      if (giftCode) {
        current = promotion(config);
        if (cart.currency !== config.promotion.currency || cartQuantity(current, cart) < Number(current.schedule.gift.minimum)) throw new Error('Your offer eligibility changed. Review your cart.');
        await adapter.apply(giftCode, cart);
        cart = await adapter.request('cart.js');
        if (!gifts.free(cart, selectedGift, giftCode)) throw new Error('The free gift could not be confirmed. Review your cart before checkout.');
        // An existing owned gift may cross a Campaign boundary. Preserve its
        // quantity/claim token and adopt it only after the new native allocation.
        const previous = list(cart.items).find(line => gifts.owned(line) && id(line.variant_id || line.id) === id(selectedGift.variantId) && line.properties._maf_campaign_gift !== id(current.schedule.id));
        if (previous) {
          await adapter.request('cart/change.js', {id:previous.key, quantity:previous.quantity, properties:{...previous.properties, _maf_campaign_gift:id(current.schedule.id)}});
          cart = await adapter.request('cart.js');
          if (!gifts.free(cart, selectedGift, giftCode)) throw new Error('Review the gift allocation in your cart before checkout.');
        }
      }
      return {cart, cartUrl:config.cartUrl, giftApplied:!!giftCode};
    } catch (error) {
      if (token) {
        try {
          const cart = await adapter.request('cart.js');
          const owned = list(cart.items).find(line => line.properties?._maf_gift_claim === token);
          if (owned && !gifts.free({...cart, items:[owned]}, selectedGift, giftCode)) await adapter.request('cart/change.js', gifts.cleanupChange(owned));
        } catch (_) {error.message += ' Refresh and inspect the gift line before trying again.';}
      }
      error.cartMayHaveChanged = attempted;
      throw error;
    } finally {commerce.busy = false; adapter.busy = false;}
  }
  function cartUrl(value) {
    const fallback = global.MAFCommerce.route('cart');
    try {const url = new URL(value || fallback, global.location.origin); return url.origin === global.location.origin && /\/cart\/?$/.test(url.pathname) ? url.pathname + url.search : fallback;} catch (_) {return fallback;}
  }
  const service = {purchase, refreshConfig, fingerprint, navigate:value => global.location.assign(cartUrl(value))};
  global.MAFCampaignPurchase = service;
  global.document.addEventListener('click', async event => {
    const button = event.target.closest('[data-maf-campaign-purchase]');
    if (!button || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    const status = button.closest('.kit-offer')?.querySelector('.kit-offer__error');
    if (!status) return;
    button.setAttribute('aria-busy', 'true'); status.hidden = true;
    let config;
    try {
      const source = global.document.getElementById(button.dataset.purchaseId);
      config = JSON.parse(source.textContent);
      const result = await service.purchase(config);
      service.navigate(result.cartUrl);
    } catch (error) {
      status.textContent = error.message; status.hidden = false;
      if (error.cartMayHaveChanged) {
        const message = 'Your cart may have changed. Review it before adding this offer again. ' + error.message;
        try {global.sessionStorage.setItem('maf-cart-discount-result', message);} catch (_) {}
        service.navigate(config?.cartUrl);
      } else {button.removeAttribute('aria-busy');}
    }
  });
})(window);
